import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import moment from 'moment';
import AddFrameworkDialog from './addframeworkdialog';
import AlertDialog from '../../common/AlertDialog';
let userDetails = getLocalStorageVariables();

class ClauseVersionDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            clauseVersion:[],
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
        
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showClauseVersionDialog){
            const frameworkObj = this.props.frameworkObj;
            this.setState({
                versionControl: frameworkObj.versionControl,
                clauseName: frameworkObj.clauseName
            },()=>{
                this.getInitData();
            })
        }
    }

    // handle edit clause dialog display event
    handleEditClause = (item) => {
        this.setState({
            isEdit:true,
            showCreateDialog:true,
            selectedItem:item,
            frameworkId:this.props.rootFrameworkId,
            childOrder:parseInt(item.childOrder),
            versionControl:isEmptyVariable(item.versionControl)?"":item.versionControl,
            clauselevel:item.clauselevel,
            parentClauseId:item.parentClauseId
        })
    }

    // handle edit clause dialog close
    handleAddEditDialogClose = (reloadFlag) => {
        this.setState({
            showCreateDialog:false,
            isEdit:false,
            createNodeType:"",
            frameworkId:"",
            clauselevel:"",
            parentClauseId:"",
            selectedItem:"",
            versionControl:""
        },()=>{
            if(reloadFlag == true){
                this.getInitData();
            }
        })
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    /*******************API CALLS*******************/
    getInitData(){
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetClauseVersion,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                versionControl:this.state.versionControl
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let clauseVersion = data.data;
                
                this.setState({
                    clauseVersion:clauseVersion,                    
                    showLoader:false,
                    componentDidMountFlag:true
                });
            }else{
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage
                });
            }
        });
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <>
                <Modal className="show-framework-tree-dialog custom-dialog" 
                show={this.props.showClauseVersionDialog} onHide={this.props.handleClauseVersionDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{this.state.clauseName}</h5>
                        <button 
                            onClick={this.props.handleClauseVersionDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="common-tab-bg">
                            <div className="common-table" style={{width:"100%"}}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th width={"60%"}></th>
                                            <th width={"20%"}>Valid From Date</th>
                                            <th width={"20%"}>Valid To Date</th>
                                            {this.props.isFrameworkEdit &&
                                                <th></th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.componentDidMountFlag &&
                                        !isEmptyArray(this.state.clauseVersion) && 
                                            this.state.clauseVersion.map((item,idx) => {
                                                return(
                                                    <tr>
                                                        <td>{item.heading}<br/>{item.description}</td>
                                                        <td>{!isEmptyVariable(item.validFromDate) ? moment(item.validFromDate).format("YYYY-MM-DD") : ""}</td>
                                                        <td>{!isEmptyVariable(item.validToDate) ? moment(item.validToDate).format("YYYY-MM-DD") : ""}</td>
                                                        {this.props.isFrameworkEdit &&
                                                            <td onClick={() => this.handleEditClause(item)}>
                                                                <span className="material-icons">edit</span>
                                                            </td>
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AddFrameworkDialog
                    isEdit={this.state.isEdit}
                    showCreateDialog={this.state.showCreateDialog}
                    handleAddEditDialogClose={this.handleAddEditDialogClose}
                    createNodeType={this.state.createNodeType}
                    frameworkId={this.state.frameworkId}
                    clauseLevel={this.state.clauselevel}
                    parentClauseId={this.state.parentClauseId}
                    rootFrameworkId={this.props.rootFrameworkId}
                    selectedItem={this.state.selectedItem}
                    childOrder={this.state.childOrder}
                    versionControl={this.state.versionControl}
                    themeSettings={this.props.themeSettings}
                    versionType={this.props.rootNode?.versionType}
                />

                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </>
        )
    }

}
export default ClauseVersionDialog;
